import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Clinic } from '../../../../shared/state/clinic/clinic.store';

@Component({
    selector: 'app-clinic-item',
    templateUrl: './clinic-item.component.html',
    styleUrls: ['./clinic-item.component.scss'],
})
export class ClinicItemComponent implements OnInit {
    @Input() clinic: Clinic;
    @Output() clinicClickedEvent = new EventEmitter<Clinic>();
    constructor() {}

    ngOnInit(): void {}

    onClinicClicked(clinic: Clinic) {
        this.clinicClickedEvent.emit(clinic);
    }
}
